import React, { FC } from "react";
import cn from "classnames";
import { ReactComponent as CategoryIcon } from "src/assets/icons/category.svg";

interface Props {
  className?: string;
  category: string;
}

export const Category: FC<Props> = ({ className, category }) => {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <CategoryIcon />
      <span className="text-purple-base text-sm md:text-lg">{category}</span>
    </div>
  );
};
